import { render, staticRenderFns } from "./RecFilterEraser.vue?vue&type=template&id=4edf57a0&scoped=true"
import script from "./RecFilterEraser.vue?vue&type=script&lang=js"
export * from "./RecFilterEraser.vue?vue&type=script&lang=js"
import style0 from "./RecFilterEraser.vue?vue&type=style&index=0&id=4edf57a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edf57a0",
  null
  
)

export default component.exports